const isMock = true;
const apiUrl = process.env.REACT_APP_API_URL;

if (!apiUrl) {
  console.warn('⚠️ Missing REACT_APP_API_URL! Check your .env file.');
}

export default { apiUrl,isMock };

